import axios from "../../apiFc24";

interface GetPlayerEvolutionsProps {
  playerRoleId: number;
  resourceId: number;
  evoPathId?: number;
}

type MetaRating = {
  chemstyleId: number;
  metaRating: number;
};

export type EvolutionPlayer = {
  rating: number;
  versionId: number;
  evolutionPath: number[];
  attributes: number[];
  metaRatings: MetaRating[];
  possiblePositions: string[];
  playStylesPlus: number[];
};

type EvolutionPlayerResponse = {
  basePlayer: Omit<EvolutionPlayer, "evolutionPath">;
  evolutionPlayers: EvolutionPlayer[];
};

export const getPlayerEvolutions = async ({
  playerRoleId,
  resourceId,
  evoPathId,
}: GetPlayerEvolutionsProps) => {
  const res = await axios.get<EvolutionPlayerResponse>(
    "/players/" +
      resourceId +
      "/evolutions?player-role-id=" +
      playerRoleId +
      (evoPathId ? "&evo-path-id=" + evoPathId : ""),
  );
  return res.data;
};
